import React from 'react';

export default function SemanticMap() {
  return (
    <iframe
      src="https://nalinplad.github.io/ucbwiki_viz/"
      style={{
        width: '100%',
        height: '600px',
        border: 'none',
        margin: '0px 0px',
      }}
      title="Semantic Map"
    />

  );
}
